<template>
  <div class='cfilter is-hidden-mobile'>
    <div class='cfilter_inner'>
      <input :checked="true" id='tab-1' name='buttons' type='radio' @click="filterClients" value="all">
      <label for='tab-1'>
        <div class='cfilter_inner__tab'>
          <h2>
          <icon name="eye" class="fa fa-eye"></icon>
          All Clients
          </h2>
          <div class='details'>
            <p>Visible is proud to have worked with a plethora of clients on projects including web development, SEO, and much more.</p>
          </div>
        </div>
      </label>
      <input id='tab-2' name='buttons' type='radio' @click="filterClients" value="agency">
      <label for='tab-2'>
        <div class='cfilter_inner__tab'>
          <h2>
            <icon name="institution" class='fa fa-institution'></icon>
            Agencies
          </h2>
          <div class='details'>
            <p>Visible has built and maintained strong relationships with some of the top agencies in Chicago and around the nation.</p>
          </div>
        </div>
      </label>
      <input id='tab-3' name='buttons' type='radio' @click="filterClients" value="seo">
      <label for='tab-3'>
        <div class='cfilter_inner__tab'>
          <h2>
            <icon name="bar-chart" class='fa fa-bar-chart'></icon>
            SEO
          </h2>
          <div class='details'>
           <p>Visible has worked with countless clients and partners to improve their search traffic. </p>
          </div>
        </div>
      </label>
      <input  id='tab-4' name='buttons' type='radio' @click="filterClients" value="dev">
      <label for='tab-4'>
        <div class='cfilter_inner__tab'>
          <h2>
            <icon name="wordpress" class='fa fa-desktop'></icon>
            Web Development
          </h2>
          <div class='details'>
            <p>Visible has built sites from the ground up for hundreds of clients.</p>
          </div>
        </div>
      </label>
      <input  id='tab-5' name='buttons' type='radio' @click="filterClients" value="code">
      <label for='tab-5'>
        <div class='cfilter_inner__tab'>
          <h2>
            <icon name="code" class='fa fa-desktop'></icon>
            Programming
          </h2>
          <div class='details'>
            <p>Visible provides custom programming solutions on both the front-end and back-end, as well as debugging.</p>
          </div>
        </div>
      </label>
      <input  id='tab-6' name='buttons' type='radio' @click="filterClients" value="design">
      <label for='tab-6'>
        <div class='cfilter_inner__tab'>
          <h2>
            <icon name="desktop" class='fa fa-desktop'></icon>
            Web Design
          </h2>
          <div class='details'>
            <p>Visible either designs or works with top designers to provide an incredible user experience for our client's sites.</p>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'clientfilter',
  data: function () {
  	return { clients: {}
	  }
  },
  methods: {
    filterClients: function (e) {
      let boxes = document.querySelectorAll(".bmv-reflective .clients .client")
      let refboxes = document.querySelectorAll(".bmv-reflection .clients .client")
      boxes.forEach((el, i) => {
        this.rafTimeout(() => {
          if (e.target.value === "all" || el.classList.contains(e.target.value)) {
            el.classList.remove('hide')
            refboxes[i].classList.remove('hide')
          } else {
            el.classList.add('hide')
            refboxes[i].classList.add('hide')
          }
         }
         , 20 * i)
      })
    },
    rafTimeout: function(fn, delay) {
      if(!window.requestAnimationFrame && !window.webkitRequestAnimationFrame && !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && !window.oRequestAnimationFrame && !window.msRequestAnimationFrame) {
        return window.setTimeout(fn, delay)
      }
      var start = new Date().getTime()
      var handle = new Object()

      function loop(){
        var current = new Date().getTime()
        var delta = current - start
        delta >= delay ? fn.call() : handle.value = window.requestAnimationFrame(loop)
      }
      handle.value = window.requestAnimationFrame(loop)
      return handle
    }
  }
}

</script>

<style lang="scss" scoped>

.bmv-reflection .cfilter {
  position:relative;
}
.cfilter{
  position:sticky;
  top:40px;
  margin:12px auto;
  box-shadow:10px 15px rgba(black, 0.2);
  // animation:intro .34s .4s cubic-bezier(1.000, 1.400, 0.410, 1.010) forwards ;
  // transform:translateY(-50%) scale(0) rotateX(10deg) rotateY(10deg) rotateZ(10deg);
  overflow:hidden;

  &_inner{
    position:relative;
    input[type="radio"]{
      display:none;
    }
    input[type="radio"]:checked + label .cfilter_inner__tab{
      height:175px;
    }
    input[type="radio"]:checked + label .cfilter_inner__tab .details{
      top:39px;
      transition:all .3s .2s cubic-bezier(0.455, 0.030, 0.515, 0.955);
    }
    input[type="radio"]:not(checked) + label .cfilter_inner__tab{
      height:80px;

    }
    input[type="radio"]:not(checked) + label .cfilter_inner__tab .details{
      top:200px;
      transition:all .3s .3s cubic-bezier(0.455, 0.030, 0.515, 0.955);
    }


    label{
      display:block;
      width:100%;
      & .cfilter_inner__tab {
        background:#fff;
        border-left: 12px solid #0099cc;
        border-bottom:1px solid #0099cc;
        &:hover {
          transition: all .2s;
          background:#eee;
        }
      }
      &:last-child .cfilter_inner__tab {
        border-bottom:none;
      }
    }
    &__tab{
      width:100%;
      height:80px;
      background:white;
      cursor:pointer;
      overflow:hidden;
      position:relative;
      transition:all .65s cubic-bezier(1.000, 0.000, 0.410, 1.010);
      h2{
        // font-weight:bold;
        position: absolute;
        left: 10px;
        top: 12px;
        color: rgb(26, 28, 29);
        font-size: 18px;
        width:100%;
        .fa-icon{
          margin:6px 6px 0px 11px;
          display:inline;
          opacity:0.3;
          transition:all .3s;
        }
      }
      .details{
        position:relative;
        top:200px;
        text-align:left;
        padding: 20px;
        p{
          font-size: 11px;
          color: grey;
        }

      }

    }
  }
}



</style>



// WEBPACK FOOTER //
// clientfilter.vue?0263381b